// THE HOVER TEXT ON A YELLOW FIELD (D-248): it names the unresolved flags the
// field is tied to (`flaggedTooltip` in `../lib/flagged.ts`). A tooltip, never
// text under the field (D-234).
//
// ALWAYS RENDERED, with or without text. The four amounts turn yellow and back
// while the reviewer types in Total, so a wrapper that came and went with the
// colour would remount the input under the cursor and drop its focus. The
// tooltip is simply kept from opening while there is nothing to say.
import { useState, type ReactElement } from 'react'
import { Tooltip, type TooltipProps } from '@fluentui/react-components'

export function FlagTooltip({
  text,
  positioning,
  children,
}: {
  text: string | undefined
  positioning?: TooltipProps['positioning']
  /** One element that takes a ref: a Fluent `Field` or `Input`, or a `div`. */
  children: ReactElement
}) {
  const [open, setOpen] = useState(false)
  return (
    <Tooltip
      content={text ?? ''}
      relationship="description"
      withArrow
      positioning={positioning}
      visible={open && !!text}
      onVisibleChange={(_e, d) => setOpen(d.visible)}
    >
      {children}
    </Tooltip>
  )
}
